<script>
    import { onMount } from "svelte";
    export let option = {
        title: {
            subtext: "",
        },
    };
    export let month;
    option.title.subtext = month;
    let chartDom;

    onMount(() => {
        //let myChart = echarts.init(chartDom, null, { renderer: "svg" });
        let myChart = echarts.init(chartDom);
        myChart.setOption(option);
    });
</script>

<div bind:this={chartDom} style="width:99%;height:99%;" />
